// removed by extract-text-webpack-plugin
module.exports = {"img":"Opportunities_img__1AV-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Opportunities/Opportunities.scss
// module id = 1071
// module chunks = 0